import React from 'react';
import { useLookups } from '../../context/LookupContext';
import StuiSelect from './StuiSelect';

const LookupSelect = ({ category, value, onChange, disabled, className, allowEmpty = true }) => {
  const { getValues } = useLookups();
  const options = getValues(category);

  return (
    <StuiSelect
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={className || 'form-input'}
    >
      {allowEmpty && <option value="">-- Select --</option>}
      {options.map(opt => (
        <option key={opt} value={opt}>{opt}</option>
      ))}
    </StuiSelect>
  );
};

export default LookupSelect;
